// Global 401 handler for the web app.
//
// When a token finally expires (they last a year) or is otherwise invalid, the
// backend answers authenticated requests with 401. Nothing used to catch that,
// so the app kept the user "logged in" from the cached user object while every
// authenticated call failed silently — empty rows, dead buttons, no explanation.
//
// Screens make scattered raw fetch() calls with no shared client, so the only
// truly global hook is a wrapper installed once over window.fetch. On a 401 it
// clears the session and reloads to a clean signed-out state, where AppMain
// shows a "session expired" notice.
//
// Two guards keep it from firing wrongly:
//   - scoped to our own backend URL, so a 401 from a third party (e.g. the
//     direct Supabase REST calls a few screens make) never logs the user out;
//   - only when a token was actually stored, so nothing happens for a logged-out
//     visitor. A failed /login returns 400, not 401, so sign-in errors are
//     unaffected regardless.

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

export function installSessionGuard() {
  if (typeof window === 'undefined' || window.__npSessionGuarded) return;
  window.__npSessionGuarded = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await originalFetch(...args);
    try {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (res.status === 401 && url.startsWith(API_URL) && localStorage.getItem('token')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.setItem('np_session_expired', '1');
        window.location.assign('/');
      }
    } catch (e) {
      // A guard must never turn a real response into a thrown error.
    }
    return res;
  };
}
